import clsx from 'clsx'

import {toAbsoluteUrl} from '_metronic/helpers'
import {getTheme, useThemeMode} from '_metronic/partials'

type Props = {
  size?: number
  alt?: string
  className?: string
  /** Set when the logo sits on an always-dark surface, so it stays white in light theme too. */
  onDarkBackground?: boolean
}

const SelectiveAiLoadingLogo = ({
  size = 72,
  alt = 'Loading',
  className,
  onDarkBackground = false,
}: Props) => {
  const {mode} = useThemeMode()
  const activeTheme = mode === 'system' ? getTheme() : mode
  // The GIF artwork is white - render it black on light-theme surfaces
  const blacken = !onDarkBackground && activeTheme !== 'dark'

  return (
    <img
      src={toAbsoluteUrl('media/logos/LogoAnim1.gif')}
      alt={alt}
      className={clsx(className)}
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        ...(blacken ? {filter: 'brightness(0) saturate(100%)'} : {}),
      }}
    />
  )
}

export default SelectiveAiLoadingLogo
